import { CultureInfo } from '../culture-info.model';
import { CultureInfoEn } from './en';

/**
 * @ignore
 */
export const CultureInfoEnMT: CultureInfo = {
  name: 'en-MT',
  displayName: 'English (Malta)',
  iso3LanguageCode: 'eng',
  iso2LanguageCode: 'en',
  ietfLanguageTag: 'en-MT',
  parent: CultureInfoEn
};
